// theme.js

// 1. import `extendTheme` function
import { extendTheme } from '@chakra-ui/react'

// 2. Add your color mode config
const config = {
    initialColorMode: 'light',
    useSystemColorMode: false,
    colors: {
        brand: {
            900: '#042d5e',
            800: '#0d74b4',
            700: '#1188d2',
        },
    }
}

// 3. extend the theme
const theme = extendTheme({ config })

export default theme